import React, { Component } from 'react';
import authService from './api-authorization/AuthorizeService'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css';
import Popup from './popup/reactjs-popup.cjs.development';
import 'reactjs-popup/dist/index.css';
import { FormattedMessage } from 'react-intl';
import { BookingControl } from './BookingControl';
import * as CalendarPlugin from '@ebarooni/capacitor-calendar';
import { Capacitor } from '@capacitor/core';

export class UserCalendar extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    this.state = {
      companies: [],
      orders: [],
      calendar: [],
      services: [],
      loading: true,
      userId: ( this.props.params ? this.props.params?.userId : 0 ) || 0,
      companyId: ( this.props.params ? this.props.params?.companyId : 0 ) || 0,
      resources: [],
      events: [],
      duration: 1,
      selectedDate: curDate,
      selectedMonth: curDate,
      otherBooking: 1,
    };
    this.selectDate = this.selectDate.bind(this);
    this.selectMonth = this.selectMonth.bind(this);
    this.renderPopupContent = this.renderPopupContent.bind(this);
    this.populateCalendarData = this.populateCalendarData.bind(this);
    this.orderCreated = this.orderCreated.bind(this);
    this.selectorRef = React.createRef(null);
  }

  async componentDidMount() {
    this.populateCompaniesData();
    await this.populateCalendarData();
    this.populateResourcesData();
    this.populateOrdersData();
    this.getCalendar();
  }

  increaseDuration(shift, res) {
    var newDur = this.state.duration + shift;
    /*if (newDur > res.maxTime / 3600)
      newDur = res.maxTime / 3600;
    if (newDur < res.minTime / 3600)
      newDur = res.minTime / 3600;*/
    if (newDur < 0.5)
      newDur = 0.5;
    if (newDur !== this.state.duration)
      this.setState(prevState => ({...prevState, duration: newDur}));
    return newDur;
  }

  displayDuration(dur, res) {
    var newDur = dur;
    //if (res.bookingInterval === 4)
    //  newDur = newDur / 24;
    return newDur;
  }

  async createOrder(resourceId, time) {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    var date = new Date(this.state.selectedDate.getTime() - this.state.selectedDate.getTimezoneOffset() * 60000);
    const response = await fetch(`{{mainApiUrl}}api/orders`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ serviceId: this.state.serviceId, resourceId: resourceId, start: time*100, end: time*100 + this.state.duration*100, date: date, partialBookingText: this.state.bookingText })
    });
    if (!response.ok) {
      return;
    }
    const data = await response.json();
    data.date = this.state.selectedDate;
    this.setState(prevState => ({...prevState, orders: [...prevState.orders, data], bookingText: undefined, otherBooking: 1}));
    this.populateCalendarData();
  }

  async cancelOrder(id) {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/orders/${id}`, {
      method: "DELETE",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) {
      return;
    }
    await response.json();
    this.setState(prevState => ({...prevState, orders: prevState.orders.filter(order => order.id !== id)}));
    this.populateCalendarData();
  }

  getContent(date) {
    var slots = this.state.calendar.filter(cal => new Date(cal.day).getTime() === date.getTime());
    return (
      slots.length > 0 ? <div class="calbardiv"><span class="calredspan" style={{height: (slots[0].sumUsed * 100 / (slots[0].sumHours>0?slots[0].sumHours:2400)).toString() + '%'}}></span><span class="calbarspan" style={{height: slots[0].slots.length>0?'100%':'0%'}}></span></div> : <div class="calbardiv"></div>
    );
  }

  renderIncreaseButton(shift, res) {
    return (
      <input style={{marginBottom: "5px", padding: "5px"}} className="btn btn-primary" type="button" value={(shift > 0 ? '+' : '') + this.displayDuration(shift, res).toString()} id="Button_Plus05" onClick={() => this.increaseDuration(shift, res)}/>
    );
  }

  isBlockedTime(pos, res) {
    return (res.endTime>res.startTime && (pos<res.startTime/100 || pos>=res.endTime/100)) || (res.endTime<res.startTime && pos>=res.endTime/100 && pos<res.startTime/100);
  }

  updateBookingText(evt) {
    const val = evt.target.value;
    this.setState(prevState => ({...prevState, bookingText: val}));
  }

  renderPopupContent(pos, res, times, resourceId, min) {
    var closeTooltip = () => this.selectorRef.current.close();
    console.log(res);
    console.log(resourceId);
    var orders = times.filter(cal => resourceId === cal.resourceId);
    var selectedDate = this.state.selectedDate.toLocaleString(undefined, {weekday: "long", year: 'numeric', month: '2-digit', day: '2-digit'});
    /*if (orders.length > 0)
      return (
        <div><div><span>Ваше бронирование на {selectedDate}</span></div>
        <div>В {Math.floor(orders[0].start / 100)}:{(orders[0].start % 100).toString().padStart(2, '0')}</div>
        {orders[0].service ? <div>Услуга: {orders[0].service}</div> : <></>}
        {orders[0].price > 0 ? <div>Цена: {orders[0].price}</div> : <></>}
        <input className="btn btn-primary" type="button" value="Cancel booking" id="Button_Cancel" onClick={() => {this.cancelOrder(orders[0].id); closeTooltip();}}/></div>
      );
    else {*/
      var incButtons = 
          <span>{this.renderIncreaseButton(/*res.timeStep > 0 ? res.timeStep / 3600 : */0.5, res)}
          {this.renderIncreaseButton(/*res.timeStep > 0 ? res.timeStep / 3600 * 2 : */1, res)}</span>;
      var decButtons = 
          <span>{this.renderIncreaseButton(/*res.timeStep > 0 ? -res.timeStep / 3600 * 2 : */-1, res)}
          {this.renderIncreaseButton(/*res.timeStep > 0 ? -res.timeStep / 3600 : */-0.5, res)}</span>;
      console.log(this.state.services);
      return (
        <div>{resourceId && orders.length === 0 ? <div><span className="radio-primary">
            <input name="OtherBooking" type="radio" value="RadioOther" id="RadioOther" checked={this.state.otherBooking === 1} onClick={() => this.setState(prevState => ({...prevState, otherBooking: 1}))}/><label className="btn btn-primary btn-tab" for="RadioOther">Бронирование</label>
            <input name="OtherBooking" type="radio" value="RadioOwn" id="RadioOwn" checked={this.state.otherBooking === 2} onClick={() => this.setState(prevState => ({...prevState, otherBooking: 2}))}/><label className="btn btn-primary btn-tab" for="RadioOwn">Перерыв</label>
            </span></div> : <></>}
          {this.state.otherBooking === 1 && resourceId ?
          <BookingControl
            selectedServiceId={0}
            services={this.state.services}
            selectedMonth={this.state.selectedMonth}
            selectedDate={this.state.selectedDate}
            orderParams={[]}
            pos={pos}
            res={res}
            orders={orders}
            min={min}
            baseOrders={orders}
            isAuthenticated={true}
            callback={this.populateCalendarData}
            completeCallback={this.orderCreated} />
           : (orders.length > 0 ?
        <div><div><span>Ваше бронирование на {selectedDate}</span></div>
        <div>В {Math.floor(orders[0].start / 100)}:{(orders[0].start % 100).toString().padStart(2, '0')}</div>
        {orders[0].service ? <div>Услуга: {orders[0].service}</div> : <></>}
        {orders[0].price > 0 ? <div>Цена: {orders[0].price}</div> : <></>}
        <input className="btn btn-primary" type="button" value="Cancel booking" id="Button_Cancel" onClick={() => {this.cancelOrder(orders[0].id); closeTooltip();}}/></div>
      :
          <><div><span>Вы создаете бронирование на {selectedDate}</span></div>
          <div>В {pos}:00</div>
          <div>На {decButtons} <b>{this.displayDuration(this.increaseDuration(0, res), res)} {this.getDurWord({bookingInterval: 3}, this.state.duration*3600)}</b> {incButtons}</div>
          <label for="Input_BookingText">Комментарий</label>
          <textarea class="form-control bookcomment" type="text" id="Input_BookingText" name="Input.BookingText" value={this.state.bookingText} onChange={evt => this.updateBookingText(evt)}/>
          <input style={{marginTop: "5px"}} className="btn btn-primary" type="button" value="Book" id="Button_New" onClick={() => {this.createOrder(res?.id, pos); closeTooltip();}}/>
          </>)}
        </div>
      );
    //}
  }

  getDurWord(service, time) {
    if (service.bookingInterval == 4) {
      if (time/86400 == 1) {
        return "день";
      }
      return `дн${time/86400>=2 && time/86400<=4?"я":"ей"}`;
    }
    var word = "час";
    if (time/3600 != 1) {
      word += time/3600>=2 && time/3600<=4?"а":"ов";
    }
    return word;
  }

  RenderPopup(pos, res, orders, resourceId, slots, min) {
    var slots0 = slots?.length > 0 ? slots[0].slots : [];
    var filtered = orders && slots?.length > 0 ? slots[0].orders
      .filter(cal => this.state.selectedDate.getTime() === new Date(cal.date).getTime() && pos >= Math.floor(cal.start / 100) && (pos + 1) < (cal.end + 99) / 100)
      .filter(cal => resourceId === cal.resourceId) : [];
    if (res && this.isBlockedTime(pos, res)) {
      return (
        <td class="calcell">
          <div class="blockedcell" style={{width: '100%'}}></div>
        </td>
      );
    }
    return (
      <Popup ref={this.selectorRef}
        className="popup-book"
        trigger={open => (
          <td class="calcell" title={filtered.map(t => t.service??t.partialBookingText + ' ' + t.userName + ' ' + t.userPhone)}>
            <div class="bookedcell" style={slots0.length > 0 && slots0[0].id === resourceId ? {maxWidth: "unset", width: (filtered.length*100/1/*res.count*/).toString() + '%'} : {width: (filtered.length*100/1/*res.count*/).toString() + '%'}}>
              {filtered.map(t => t.service??t.partialBookingText)}
            </div>
            <div class="availcell" style={{width: filtered.length > 0/*=== res.count*/?'0%':'100%'}}></div>
          </td>
        )}
        onClose={() => this.setState(prevState => ({...prevState, duration: 1}))}
        position="bottom center"
        closeOnDocumentClick>{() => this.renderPopupContent(pos, res, filtered, resourceId, min)}</Popup>
    );
  }

  RenderRow(pos, res, min) {
    var orders = this.state.orders.filter(cal => this.state.selectedDate.getTime() === new Date(cal.date).getTime() && pos >= Math.floor(cal.start / 100) && (pos + 1) < (cal.end + 99) / 100);
    var slots = this.state.calendar.filter(cal => new Date(cal.day).getTime() === this.state.selectedDate.getTime());
    var startTime = new Date(this.state.selectedDate.getFullYear(), this.state.selectedDate.getMonth(), this.state.selectedDate.getDate(), pos, 0, 0, 0);
    var endTime = new Date(startTime);
    endTime.setHours(endTime.getHours() + 1);
    return (
      <tr key={pos}>
        <th class="thleft">{pos}:00</th>
        {slots?.length > 0 && slots[0].slots.length > 0 && this.state.resources.filter(r => r.id === slots[0].slots[0].id).length > 0 ?/*this.state.resources.map(res => */this.RenderPopup(pos, this.state.resources.filter(r => r.id === slots[0].slots[0].id)[0], orders, slots[0].slots[0].id, slots, min):<></>/*)*/}
        {this.RenderPopup(pos, null, null, null, slots, min)}
        {orders.filter(cal => !slots || slots.length === 0 || slots[0].slots.length === 0 || slots[0].slots[0].id !== cal.resourceId).map(t => this.RenderPopup(pos, /*res*/null, orders, t.resourceId, slots, min)/*<td class="calcell" title={'At '+(t.start / 100).toString()+':00 in '+ t.company}><div class="bookedcell" style={{width: '100%'}}>{t.service}</div></td>*/)}
        {this.state.events.filter(cal => cal.startDate<endTime.getTime() && cal.endDate>startTime.getTime()).map(cal =>           <td class="calcell" title="Данные из календаря">
            <div class="bookedcell" style={{maxWidth: "unset", width: '100%'}}>
              {cal.title}
            </div>
          </td>
/*<td class="calcell" title={'At '+(t.start / 100).toString()+':00 in '+ t.company}><div class="bookedcell" style={{width: '100%'}}>{t.service}</div></td>*/)}
      </tr>
    );
  }

  selectDate(date, event) {
    this.setState(prevState => ({...prevState, selectedDate: date}));
    this.populateOrdersData();
    this.populateResourcesData();
    this.getCalendar();
  }

  async selectMonth({action, activeStartDate, value, view}) {
    this.setState(prevState => ({...prevState, selectedMonth: activeStartDate}));
    await this.populateCalendarData();
    this.populateResourcesData();
  }

  orderCreated() {
    this.setState(prevState => ({...prevState, calendar: this.state.temporders, temporders: null}));
  }

  async getCalendar() {
    if (this.state.eventsDate === this.state.selectedDate) {
      return;
    }
    this.setState(prevState => ({...prevState, loadingCalendar: true, events: [] }));
    if (!Capacitor.isNativePlatform()) {
      return;
    }
    try {
      const permissionResult = await CalendarPlugin.CapacitorCalendar.requestPermissions();
      if (permissionResult.readCalendar === 'granted' || permissionResult.writeCalendar === 'granted' || permissionResult.readWriteCalendar === 'granted') {
        const calendars = await CalendarPlugin.CapacitorCalendar.listCalendars();
        console.log('Calendars:', calendars.result?.length);
        if (calendars.result?.length > 0) {
          const now = this.state.selectedDate;
          const startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        
          const events = await CalendarPlugin.CapacitorCalendar.listEventsInRange({
            from: startDate.getTime() - startDate.getTimezoneOffset() * 60000,
            to: startDate.getTime() - startDate.getTimezoneOffset() * 60000 + 86400000
          });
        
          this.setState(prevState => ({...prevState, events: events?.result ?? [], eventsDate: new Date(this.state.selectedDate) }));
          console.log('Calendar loaded:', events);
        }
      } else {        
      }
    } catch (error) {
      console.error('Calendar error:', error);
    } finally {
      this.setState(prevState => ({...prevState, loadingCalendar: false }));
    }
  }

  renderCalendar() {
    var slots = this.state.calendar.filter(cal => new Date(cal.day).getTime() === this.state.selectedDate.getTime());
    var daylengths = Array.from(Array(24).keys()).map(pos => this.state.orders.filter(cal => this.state.selectedDate.getTime() === new Date(cal.date).getTime() && pos >= Math.floor(cal.start / 100) && (pos + 1) < (cal.end + 99) / 100 && (slots.length === 0 || slots[0].slots.length === 0 || slots[0].slots[0].id !== cal.resourceId)).length);
    var columns = Math.max(...daylengths.map(o => o));
    return (
      <div>
      <Calendar
        tileContent={({ date, view }) => view === 'month' ? this.getContent(date) : null}
        onChange={this.selectDate} onActiveStartDateChange={this.selectMonth} value={this.state.selectedDate}/>

      <table style={{borderCollapse: "separate"}} className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th style={{zIndex: "2"}} width="20px"><FormattedMessage id="time"/></th>
            {/*this.state.resources.map(res =>
              <th width="100px"><div><img width="50px" height="50px" alt="" src={res.images[0]}/></div>{res.name}({res.count})</th>
            )*/}
            {slots.length > 0 && slots[0].slots.length > 0 && this.state.resources.filter(r => r.id === slots[0].slots[0].id).length > 0 ? <th class="thtop">{slots[0].slots[0].company}</th> : <></>}
            <th width="20px">Собственный</th>
            {columns ? Array.from(Array(columns).keys()).map(pos => <th class="thtop"></th>) : <></>}
            <th class="thtopright"></th>
          </tr>
        </thead>
        <tbody>
          {Array.from(Array(24).keys()).map(pos => this.RenderRow(pos, null, 0))}
        </tbody>
      </table>
      </div>
    );
  }

  render() {
    let calendar = this.state.loading
      ? <p><em><FormattedMessage id="loading"/></em></p>
      : this.renderCalendar();

    return (
      <div>
        <div>
          <h4 id="tabelLabel" class="leftheader"><FormattedMessage id="your_calendar"/></h4>
          {this.state.companies.map(c =>
          <a style={{margin: "0 5px 5px 0"}} class="text-dark btn-book nav-link" href={`/booking/${c.id}`}>Календарь {c.name}</a>)}
        </div>
        {calendar}
      </div>
    );
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) {
      return;
    }
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
  }

  async populateOrdersData() {
    const token = await authService.getAccessToken();
    var date = new Date(this.state.selectedDate.getTime() - this.state.selectedDate.getTimezoneOffset() * 60000);
    var url = this.state.companyId > 0
      ? `{{mainApiUrl}}api/orders/${this.state.companyId}`
      : `{{mainApiUrl}}api/orders`;
    url += `?date=${date.toLocaleDateString('en-US')}`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) {
      return;
    }
    const data = await response.json();
    this.setState(prevState => ({...prevState, orders: data}));
  }

  async populateCalendarData(temporders) {
    const token = await authService.getAccessToken();
    var date = new Date(this.state.selectedMonth.getTime() - this.state.selectedMonth.getTimezoneOffset() * 60000);
    var url = this.state.companyId > 0 
      ? `{{mainApiUrl}}api/orders/user/0/${this.state.companyId}`
      : `{{mainApiUrl}}api/orders/user`;
    url += `?month=${date.toLocaleDateString('en-US')}`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) {
      return;
    }
    const data = await response.json();
    if (temporders) {
      this.setState(prevState => ({...prevState, temporders: data}));
    } else {
      this.setState(prevState => ({...prevState, calendar: data, loading: false}));
      this.populateServicesData();
    }
  }

  async populateServicesData() {
    const token = await authService.getAccessToken();
    var slots = this.state.calendar.filter(cal => new Date(cal.day).getTime() === this.state.selectedDate.getTime());
    if (slots.length == 0 || slots[0].slots.length == 0) {
      this.setState(prevState => ({...prevState, services: []}));
      return;
    }
    var url = `{{mainApiUrl}}api/companies/${slots[0].slots[0].companyId}/${slots[0].slots[0].id}/services`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) {
      return;
    }
    const data = await response.json();
    this.setState(prevState => ({...prevState, services: data}));
    console.log(data);
  }

  async populateResourcesData() {
    const token = await authService.getAccessToken();
    var date = new Date(this.state.selectedDate.getTime() - this.state.selectedDate.getTimezoneOffset() * 60000);
    var slots = this.state.calendar.filter(cal => new Date(cal.day).getTime() === this.state.selectedDate.getTime());
    if (slots.length == 0 || slots[0].slots.length == 0) {
      this.setState(prevState => ({...prevState, resources: []}));
      return;
    }
    var url = `{{mainApiUrl}}api/services/0/resources/${slots[0].slots[0].companyId}`;
    url += `?date=${date.toLocaleDateString('en-US')}`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) {
      return;
    }
    const data = await response.json();
    this.setState(prevState => ({...prevState, resources: data}));
  }
}
